import { useApplicationContext } from '../../utils/applicationContext';

import { IProgram, DomrfCalculator, IProps as IDomrfCalculatorProps } from '@cian/frontend-domrf-calculator';
import { MortgageContainer, MortgageContainerMobile } from '../MortgageContainer';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuilder, selectProject } from '../../selectors';
import { selectLocationId } from '../../selectors/location';
import { Section } from '../../components/Section';
import { isBuilderWithEscrow } from '../../utils/builder/isBuilderWithEscrow';
import { useDeviceType } from '@cian/ui-kit';

type TTextData = Pick<
  IDomrfCalculatorProps,
  'title' | 'subtitle' | 'priceTooltipTitle' | 'priceTooltipText' | 'escrowTooltipText' | 'escrowTooltipTitle'
>;

const MORTGAGE_COMPONENTS = {
  desktop: MortgageContainer,
  tablet: MortgageContainerMobile,
  phone: MortgageContainerMobile,
};

export const MortgageCalculatorContainer = () => {
  const { config } = useApplicationContext();
  const regionId = useSelector(selectLocationId);
  const { startPrice, id: projectId } = useSelector(selectProject);
  const { id: builderId } = useSelector(selectBuilder);

  const domrfPrograms = config.get<IProgram[]>('audience.domrfMortgage.programs');
  const textData = config.get<TTextData>('audience.domrfMortgage.textData');

  const device = useDeviceType();

  /* istanbul ignore else */
  if (!domrfPrograms) {
    const MortgageCalculatorComponent = MORTGAGE_COMPONENTS[device];

    return <MortgageCalculatorComponent />;
  }

  return (
    <Section>
      <DomrfCalculator
        programs={domrfPrograms}
        regionId={regionId}
        startPrice={startPrice}
        pageType="project"
        withEscrow={isBuilderWithEscrow(builderId, config)}
        objectId={projectId}
        {...textData}
      />
    </Section>
  );
};
